export class Texture {
  constructor(type, category, categoryID, attributes) {
    this.type = type;
    this.category = category;
    this.catID = categoryID;
    this.uid = attributes.textureUID;
    this.name = attributes.textureName;
    this.code = attributes.textureCode;
    this.extraCost = attributes.extraCost;
    this.iconSrc = attributes.textureIcon;
    this.frontSrc = attributes.textureFront;
    this.backSrc = attributes.textureBack;
    this.unavailable = attributes.unavailable;
    this.noColorlessStamping = attributes.noColorlessStamping;
    this.iconImage = undefined;
    this.frontImage = undefined;
    this.backImage = undefined;
    this.loaded = false;
  }
  getCategory() {
    return this.category;
  }
  getUID() {
    return this.uid;
  }
  getName() {
    return this.name;
  }
  getFrontSrc() {
    return this.frontSrc;
  }
  getBackSrc() {
    return this.backSrc;
  }
  setFrontImage(image) {
    this.frontImage = image;
  }
  setBackImage(image) {
    this.backImage = image;
  }
  async load() {
    let backPromise, frontPromise, iconPromise;
    if (this.backSrc) {
      backPromise = new Promise((backResolve) => {
        const loadBackImage = () =>{
          const bImage = new Image();
          bImage.crossOrigin = 'Anonymous'
          bImage.addEventListener("load", () => {
            this.backImage = bImage;
            backResolve(this.backImage);
          });
          bImage.addEventListener("error", () => {
            setTimeout(() => {
              loadBackImage();
            }, 500);
          });
          bImage.src = this.backSrc;
        }
        loadBackImage();
      });
    }
    if (this.frontSrc) {
      frontPromise = new Promise((frontResolve) => {
        const loadFrontImage = () =>{
          const fImage = new Image();
          fImage.crossOrigin = 'Anonymous'
          fImage.addEventListener("load", () => {
            this.frontImage = fImage;
            frontResolve(this.frontImage);
          });
          fImage.addEventListener("error", () => {
            setTimeout(() => {
              loadFrontImage();
            }, 500);
          });
          fImage.src = this.frontSrc;
        }
        loadFrontImage();
      });
    }
    if (this.iconSrc) {
      iconPromise = new Promise((iconResolve) => {
        const loadIconImage = () =>{
          const iImage = new Image();
          iImage.addEventListener("load", () => {
            this.iconImage = iImage;
            iconResolve(this.iconImage);
          });
          iImage.addEventListener("error", () => {
            setTimeout(() => {
              loadIconImage();
            }, 500);
          });
          iImage.src = this.iconSrc;
        }
        loadIconImage();
      });
    }
    await Promise.all([backPromise, frontPromise, iconPromise])
      .then((result) => {
        this.loaded = true;
        // console.log(result);
      })
      .catch((err) => {
        console.error(err);
      });
  }
  /*
  async load() {
    let backPromise, frontPromise, iconPromise;
    if (this.backSrc) {
      backPromise = new Promise((backResolve) => {
        const bImage = new Image();
        bImage.crossOrigin = 'Anonymous'
        bImage.addEventListener("load", () => {
          this.backImage = bImage;
          backResolve(this.backImage);
        });
        bImage.src = this.backSrc;
      });
    }
    if (this.frontSrc) {
      frontPromise = new Promise((frontResolve) => {
        const fImage = new Image();
        fImage.crossOrigin = 'Anonymous'
        fImage.addEventListener("load", () => {
          this.frontImage = fImage;
          frontResolve(this.frontImage);
        });
        fImage.src = this.frontSrc;
      });
    }
    if (this.iconSrc) {
      iconPromise = new Promise((iconResolve) => {
        const iImage = new Image();
        iImage.addEventListener("load", () => {
          this.iconImage = iImage;
          iconResolve(this.iconImage);
        });
        iImage.src = this.iconSrc;
      });
    }
    await Promise.all([backPromise, frontPromise, iconPromise])
      .then((result) => {
        this.loaded = true;
        console.log(result);
      })
      .catch((err) => {
        console.error(err);
      });
  }
      */
}